<template>
  <div class="p-0 m-0 font-poppins">
    <!-- NavBar para móviles -->
    <NavBarComponent
      v-show="isSessionActive && sessionStep >= 3"
      class="block sm:block md:hidden"
    />
    
    <!-- DeskNavBar para desktop -->
    <DeskNavBar
      v-show="isSessionActive && sessionStep >= 3"
      :class="[
        'hidden md:block top-0 left-0 right-0 z-30 transition-all duration-300',
        isSidebarCollapsed ? 'md:pl-[60px]' : 'md:pl-[15%]'
      ]"
    />
    
    <div class="flex" :class="{ 'sm:mt-0': isSessionActive && sessionStep >= 3 }">
      <SideBarComponent
        v-show="isSessionActive"
        :class="[
          'hidden md:block bg-black fixed transition-all duration-300',
          isSidebarCollapsed ? 'w-[60px]' : 'w-[15%]'
        ]"
        @toggle-collapse="toggleSidebar"
        :is-collapsed="isSidebarCollapsed"
      />
      <main
        :class="[
          mainClass,
          'flex-1 w-full sm:w-full ml-0 h-mx-auto transition-all duration-300',
          isSessionActive ? [
              sessionStep < 3 ? 'sm:w-[85%]' : 'sm:w-[85%] p-4',
              isSidebarCollapsed ? 'sm:ml-[60px]' : 'sm:ml-[15%]',
          ] : '',
        ]"
      >
        <!-- Contenedor principal para la información -->
        <router-view />
      </main>
    </div>
    <WhatsappComponente />
  </div>
</template>

<script>
import { onMounted, computed, ref } from "vue";
import { useStore } from "vuex";
import NavBarComponent from "./components/NavBarComponent.vue";
import DeskNavBar from "./components/DeskNavBar.vue";
import SideBarComponent from "./components/SideBarComponent.vue";
import WhatsappComponente from "./components/WhatsappComponente.vue";

export default {
  components: {
    NavBarComponent,
    DeskNavBar,
    SideBarComponent,
    WhatsappComponente,
  },
  setup() {
    const store = useStore();

    // Cargar la sesión cuando la aplicación se inicia
    onMounted(() => {
      store.dispatch("loadUserSession");
    });

    // Computed para verificar si la sesión está activa
    const isSessionActive = computed(() => store.getters.getUserSession);

    // Computed para obtener el step de la sesión
    const sessionStep = computed(() => {
      const session = store.getters.getUserSession;
      return session && session.step ? session.step : 0;
    });

    // Cambiar la clase de main según la sesión
    const mainClass = computed(() => {
      return isSessionActive.value ? "bg-white" : "bg-white ";
    });

    const isSidebarCollapsed = ref(true);

    const toggleSidebar = () => {
      isSidebarCollapsed.value = !isSidebarCollapsed.value;
    };

    return {
      isSessionActive,
      sessionStep,
      mainClass,
      isSidebarCollapsed,
      toggleSidebar,
    };
  },
};
</script>

<style scoped>
</style>


